var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21836 1.7749C3.4859 1.7749 2.07947 3.18134 2.07947 4.91379V11.136C2.07947 12.8685 3.4859 14.2749 5.21836 14.2749H11.4406C13.173 14.2749 14.5795 12.8685 14.5795 11.136V4.91379C14.5795 3.18134 13.173 1.7749 11.4406 1.7749H5.21836ZM0.579468 4.91379C0.579468 2.35291 2.65748 0.274902 5.21836 0.274902H11.4406C14.0015 0.274902 16.0795 2.35291 16.0795 4.91379V11.136C16.0795 13.6969 14.0015 15.7749 11.4406 15.7749H5.21836C2.65748 15.7749 0.579468 13.6969 0.579468 11.136V4.91379ZM12.2183 5.30257C12.8626 5.30257 13.385 4.78024 13.385 4.1359C13.385 3.49157 12.8626 2.96924 12.2183 2.96924C11.574 2.96924 11.0516 3.49157 11.0516 4.1359C11.0516 4.78024 11.574 5.30257 12.2183 5.30257ZM5.96838 8.02469C5.96838 6.72001 7.02482 5.66357 8.32949 5.66357C9.63417 5.66357 10.6906 6.72001 10.6906 8.02469C10.6906 9.32936 9.63417 10.3858 8.32949 10.3858C7.02482 10.3858 5.96838 9.32936 5.96838 8.02469ZM8.32949 4.16357C6.19639 4.16357 4.46838 5.89158 4.46838 8.02469C4.46838 10.1578 6.19639 11.8858 8.32949 11.8858C10.4626 11.8858 12.1906 10.1578 12.1906 8.02469C12.1906 5.89158 10.4626 4.16357 8.32949 4.16357Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c95117da84ea2a0cef7f8310389acfc1.svg";
export { ForwardRef as ReactComponent };